<template>
  <div class="point_complete" v-if="order != null">
    <section class="text_center">
      <h2 class="header_underline">クレジット決済完了</h2>
      <p>購入内容</p>
      <table class="table white brown">
        <tr>
          <th>決済金額</th>
          <th>追加ポイント</th>
        </tr>
        <tr>
          <td>{{ order.price.toLocaleString() }}円</td>
          <td>{{ order.point }}pt</td>
        </tr>
      </table>
      <p>
        <router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
import { GET_ORDER_COMPLETE } from '@/store/point/actions'

export default {
  name: 'PointCreditTelecomComplete',
  data () {
    return {
      paymentWay: 'credit_telecom',
      oid: this.$route.query.oid || 0,
      order: null
    }
  },
  methods: {
    getOrderComplete () {
      if (this.oid === 0) {
        return
      }

      this.$store.dispatch(GET_ORDER_COMPLETE, {
        id: this.oid,
        paymentWay: this.paymentWay
      })
        .then((data) => {
          this.order = data
        })
        .catch(() => {
          this.$router.pushIsses({ name: 'PointCreditTelecomError' })
        })
    }
  },
  created () {
    this.getOrderComplete()
  }
}
</script>
